import { createContext } from "react";

export const AdminLoginContext = createContext({});
